import React from 'react';
import { observer } from 'mobx-react-lite';

import BetInputSection from './betInputSection';
import QuickButtonsSection from './quickButtonsSection';

const BetInput = observer(
  ({
    t,
    limits,
    onBlur,
    onChange,
    betAmount,
    activeFreeBet,
    handleOpenNumPad,
    showNotification,
    setIsValidatedAmount,
    handleChangeInputValue,
  }) => {
    return (
      <div className={`monti-calc-actions  ${activeFreeBet.id ? 'passive' : ''}  `}>
        <BetInputSection
          onBlur={onBlur}
          onChange={onChange}
          betAmount={betAmount}
          handleOpenNumPad={handleOpenNumPad}
          showNotification={showNotification}
          setIsValidatedAmount={setIsValidatedAmount}
          handleChangeInputValue={handleChangeInputValue}
        />
        <QuickButtonsSection
          t={t}
          limits={limits}
          betAmount={betAmount}
          handleChangeInputValue={handleChangeInputValue}
        />
      </div>
    );
  }
);

export default BetInput;
